import { render, staticRenderFns } from "./TabUnitExchange.vue?vue&type=template&id=0afd9d8a&"
import script from "./TabUnitExchange.vue?vue&type=script&lang=ts&"
export * from "./TabUnitExchange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0afd9d8a')) {
      api.createRecord('0afd9d8a', component.options)
    } else {
      api.reload('0afd9d8a', component.options)
    }
    module.hot.accept("./TabUnitExchange.vue?vue&type=template&id=0afd9d8a&", function () {
      api.rerender('0afd9d8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DailyOperationalReport/TabUnitExchange.vue"
export default component.exports